export const trackFeatureAppReady = (trackingService, availableCategories, results, appliedFilters, isUsedCarMkt) => {
    if (trackingService) {
        trackingService.track({
            event: {
                eventInfo: {
                    eventAction: 'feature_app_ready',
                    eventName: 'vtp product list page',
                },
                attributes: {
                    componentName: 'vtp-filter',
                    label: '',
                    targetURL: '',
                    clickID: '',
                    elementName: '',
                    value: '',
                    pos: '',
                },
            },
            componentUpdate: {
                attributes: {
                    version: '',
                    implementer: 37,
                    availableCategories,
                },
                search: {
                    name: isUsedCarMkt ? 'vtp search - used' : 'vtp search - new',
                    term: '',
                    results,
                    filter: appliedFilters,
                },
            },
        });
    }
};
export const trackClicks = (trackingService, eventName, label, elementName, value, isTriggeredByOpeningBrowserSearch) => {
    if (trackingService) {
        trackingService.track({
            event: {
                eventInfo: {
                    eventAction: isTriggeredByOpeningBrowserSearch ? 'content' : 'navigation',
                    eventName,
                },
                attributes: {
                    componentName: 'vtp-filter',
                    label,
                    targetURL: '',
                    clickID: '',
                    elementName,
                    value,
                    pos: '',
                },
            },
        });
    }
};
export const trackCloseAdvancedFilters = (trackingService, label, elementName) => {
    if (trackingService) {
        trackingService.track({
            event: {
                eventInfo: {
                    eventAction: 'navigation',
                    eventName: 'vtp filter - click to show results - layer close',
                },
                attributes: {
                    componentName: 'vtp-filter',
                    label,
                    targetURL: '',
                    clickID: '',
                    elementName,
                    value: '',
                    pos: '',
                },
            },
            componentUpdate: {
                page: {
                    pageInfo: {
                        layerName: [],
                    },
                },
            },
        });
    }
};
export const trackOneFilterChange = (trackingService, eventName, label, value, changedFilter, relatedFilters, results, isUsedCarMkt) => {
    const updatedRelatedFilters = relatedFilters.length > 0
        ? relatedFilters.filter((item, index, array) => array.findIndex((other) => other.id === item.id) === index)
        : relatedFilters;
    if (trackingService) {
        trackingService.track({
            event: {
                eventInfo: {
                    eventAction: 'filter',
                    eventName,
                },
                attributes: {
                    componentName: eventName.startsWith('vtp quick filter')
                        ? 'vtp-quick-filter'
                        : 'vtp-filter',
                    label,
                    targetURL: '',
                    clickID: '',
                    elementName: '',
                    value,
                    pos: '',
                    relatedFilters: changedFilter,
                },
            },
            componentUpdate: {
                attributes: {
                    version: '',
                    search: {
                        name: isUsedCarMkt ? 'vtp search - used' : 'vtp search - new',
                        term: '',
                        results,
                        filter: updatedRelatedFilters,
                    },
                },
            },
        });
    }
};
export const trackRemoveAllFilters = (trackingService, eventName, elementName, label, relatedFilters, results, isUsedCarMkt) => {
    const idsToRemove = new Set();
    relatedFilters.forEach((item) => {
        item.values.forEach((value) => idsToRemove.add(value));
    });
    const cleanRelatedFilters = relatedFilters.filter((item) => !idsToRemove.has(item.id));
    if (trackingService) {
        trackingService.track({
            event: {
                eventInfo: {
                    eventAction: 'filter',
                    eventName,
                },
                attributes: {
                    componentName: 'vtp-filter',
                    label,
                    targetURL: '',
                    clickID: '',
                    elementName,
                    value: '',
                    pos: '',
                    relatedFilters: cleanRelatedFilters,
                },
            },
            componentUpdate: {
                attributes: {
                    version: '',
                    search: {
                        name: isUsedCarMkt ? 'vtp search - used' : 'vtp search - new',
                        term: '',
                        results,
                        filter: [],
                    },
                },
            },
        });
    }
};
export const trackImpression = (trackingService, value, overalImpression) => {
    if (trackingService) {
        trackingService.track({
            event: {
                eventInfo: {
                    eventAction: 'impression',
                    eventName: overalImpression
                        ? 'vtp filter - impression'
                        : 'vtp filter - category impression',
                },
                attributes: {
                    componentName: 'vtp-filter',
                    label: '',
                    targetURL: '',
                    clickID: '',
                    elementName: '',
                    value,
                    pos: '',
                },
            },
        });
    }
};
export const trackGiveConsent = (trackingService, label) => {
    if (trackingService) {
        trackingService.track({
            event: {
                eventInfo: {
                    eventAction: 'content',
                    eventName: `vtp quick filter - give consent to map`,
                },
                attributes: {
                    componentName: 'vtp-quick-filter',
                    label,
                    targetURL: '',
                    clickID: '',
                    elementName: 'button',
                    value: '',
                    pos: '',
                },
            },
        });
    }
};
export const trackRemoveConsent = (trackingService) => {
    if (trackingService) {
        trackingService.track({
            event: {
                eventInfo: {
                    eventAction: 'content',
                    eventName: `vtp quick filter - remove consent to map`,
                },
                attributes: {
                    componentName: 'vtp-quick-filter',
                    label: '',
                    targetURL: '',
                    clickID: '',
                    elementName: 'other',
                    value: '',
                    pos: '',
                },
            },
        });
    }
};
